// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import Accordion from '../../../../shared/components/accordion';
import {FormattedMessage} from 'react-intl';
import ProductHierarchy from '../../../../shared/components/facets/product-hierarchy';
import ProductHierarchyModel from '@deere/cps-it.warranty-model-factory/lib/product-hierarchy';

const ProductHierarchyFacet = props => {

    const body = (
        <ProductHierarchy
            filterPlaceholder='PRODUCTS'
            onProductHierarchyChange={props.onSelectProductCode}
            productHierarchy={props.allowedProductHierarchy}
            selectedProductCode={props.selectedProductCode}
        />
    );

    const title = <FormattedMessage id='PRODUCTS'/>;

    return (
        <section className='claim-types'>
            <Accordion
                accordionId='product-hierarchy-accordion'
                body={body}
                isExpanded={props.isExpanded}
                onClick={props.onClick}
                title={title}
            />
        </section>
    );

};

ProductHierarchyFacet.displayName = 'ProductHierarchyFacet';
ProductHierarchyFacet.propTypes = {
    allowedProductHierarchy: PropTypes.instanceOf(ProductHierarchyModel).isRequired,
    isExpanded: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    onSelectProductCode: PropTypes.func.isRequired,
    selectedProductCode: PropTypes.string.isRequired
};

export default ProductHierarchyFacet;




// WEBPACK FOOTER //
// ./src/tcsm/claim-search/components/facets/product-hierarchy.js